import axios from 'axios';

// Set per environment in .env.development / .env.production. The localhost
// value is only a fallback for a checkout with no env file at all.
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5006/api';

// Create axios instance
const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Request interceptor to add auth token
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor to handle errors
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            // Check if the request was for auth endpoints
            // We don't want to redirect/refresh if the user is just failing to login/verify
            const isAuthRequest = error.config.url && (
                error.config.url.includes('/auth/login') ||
                error.config.url.includes('/auth/verify-otp')
            );

            if (!isAuthRequest) {
                // Unauthorized - clear token and redirect to login
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    }
);

/**
 * Absolute URL for a file served by the API (uploads live beside /api, not
 * under it). Derived from the API base so it follows the deployment: a
 * relative base yields a same-origin path, an absolute one keeps the host.
 */
const FILE_ORIGIN = String(API_URL).replace(/\/api\/?$/, '');

export const fileUrl = (filePath) =>
    `${FILE_ORIGIN}/${String(filePath || '').replace(/^\/+/, '')}`;

export default api;
